export default {
  PATIENTAPP: 'PATIENTAPP',
  MANUAL: 'MANUAL',
  UNASSIGNED: 'UNASSIGNED',
} as const
